import React, { useState } from 'react'
// import { SwatchesPicker } from 'react-color'
import { Button } from 'adl'
import { Row, Col } from 'react-grid-system'
import styled from 'styled-components'

const SwatchBG = styled.div`
  background-color: #ffff;
  border-radius: 0.25rem;
  height: 2rem;
  padding: 0.25rem;
  display: flex;
  flex-direction: row;
  align-items: center;
`

const SwatchColor = styled.div`
  width: 2rem;
  height: 100%;
  border-radius: 0.2rem;
`
const Swatch = ({ color, children, ...rest }) => (
  <SwatchBG {...rest}>
    <SwatchColor style={{ backgroundColor: color, marginRight: 4 }} />
    {children}
  </SwatchBG>
)

const ShowOnHover = styled.div`
  opacity: 0;
  transition: opacity 300ms ease;
  font-weight: 500;
  width: 128px;
  &:hover {
    opacity: 1;
  }
  ${props => (props.active ? `opacity: 1` : null)};
`

const Inspector = styled.div`
  position: fixed;
  bottom: 4rem;
  right: 1rem;
  background-color: white;
  padding: 1rem;
  border-radius: 0.25rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 300px;
`

export default ({ currentPreset, presets, onChange }) => {
  const [showInspector, setShowInspector] = useState(false)
  return (
    <div style={{ position: 'fixed', bottom: 0, right: 0, padding: '1rem' }}>
      <ShowOnHover active={showInspector}>
        <Swatch
          color={currentPreset.theme.colors.interactive}
          onClick={() => setShowInspector(!showInspector)}
          style={{
            cursor: 'pointer',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
          }}
        >
          {currentPreset.label}
        </Swatch>

        {showInspector && (
          <Inspector>
            <Row>
              {presets.map((p, index) => (
                <Col key={index} xs={6}>
                  <Button
                    block
                    onClick={() => {
                      onChange(p)
                      setShowInspector(false)
                    }}
                    style={{
                      justifyContent: 'flex-start',
                      marginBottom: index < presets.length - 1 ? '0.5rem' : 0
                    }}
                  >
                    <SwatchColor
                      style={{
                        backgroundColor: p.theme.colors.interactive,
                        marginRight: 8,
                        width: 16,
                        height: 16
                      }}
                    />{' '}
                    {p.label}
                  </Button>
                </Col>
              ))}
            </Row>
          </Inspector>
        )}
      </ShowOnHover>
    </div>
  )
}
